import moment from 'moment-timezone';

export const DATE_FORMAT = 'DD/MM/YYYY';

export const dateBySlash = (date: Date) => (
  date ? moment(date).format(`${DATE_FORMAT}`) : '-'
);
